export default {
  screens: [
    {
      type: 'intro',
      title: '아트 오브 디아뎀',
      content:
        '주얼리의 정수이자 쇼메의 상징이며 권력을 나타내는 아이콘 또는 패션 액세서리로 여겨지기도 한 티아라는 전통적 형태와 현대적 형태를 아우르며 다양한 디자인을 선보입니다.',
      idYt: '2YX1UzJIlp0',
      videoCover: 'world/diademe/video.jpg',
      desktop: {
        cover: 'world/diademe/cover-1.jpg'
      },
      mobile: {
        cover: 'world/diademe/mobile-cover-1.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: 'auto',
          height: '65%',
          bottom: '-18%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      },
      isCover: true
    },
    {
      type: 'triangle',
      desktop: {
        topImg: 'world/diademe/triangleTop.jpg',
        btmImg: 'world/diademe/triangleBtm.jpg',
        cover: 'world/diademe/cover-2.jpg'
      },
      mobile: {
        topImg: 'world/diademe/triangleTop.jpg',
        btmImg: 'world/diademe/triangleBtm.jpg',
        cover: 'world/diademe/cover-2.jpg'
      },
      content:
        '1780년부터 쇼메는 왕실과 유명 귀족 가문을 위해 2,000개 이상의 디아뎀과 머리 장신구 및 아그레트를 제작했습니다. <br/><br/> 전시회에 소개되는 20여 개의 디아뎀과 실제로 제작되었던 300개 디아뎀 모형은 쇼메의 창의성과 탁월한 기술력을 보여 줍니다.',
      isCover: true
    },
    {
      type: 'grid',
      videoBlock: {
        cover: 'world/diademe/video-diademe.jpg',
        idYt: 'IM2d5lCTqIA'
      },
      middleImg: 'world/diademe/gridMiddle.jpg',
      rightImg: 'world/diademe/gridRight.jpg',
      title: '베르티지(Vertiges) 디아뎀',
      content:
        '영국 센트럴 세인트 마틴 (Central Saint Martins) 학생들에게 21세기 디아뎀의 제작이라는 쇼메의 도전 과제가 주어졌습니다.<br/><br/> 스콧 암스트롱(Scott Armstrong)이 프랑스식 정원을 재해석한 베르티지(Vertiges) 디아뎀을 선보였습니다. 곡선과 직선의 조화를 통해 탄생된 디아뎀은 쇼메의 세계에 대한 새로운 시각을 보여 줍니다.'
    }
  ],
  mobile: {
    mainContentStyle: { paddingBottom: '20px' }
  }
}



// WEBPACK FOOTER //
// ./src/locales/kr/worlds/diademe.js